module.exports = __webpack_public_path__ + "img/img_target_top_af.d9384895.svg";